export const removeNullProperties = (obj:any) => {
  Object.keys(obj).forEach((key:string) => {
    let value = obj[key];
    let hasProperties = value && Object.keys(value).length > 0;
    if ((value === null) || (value === 'null') || (value === '')) {
      delete obj[key];
    }
    if ((key === null) || (key === 'null') || (key === '')) {
      delete obj[key];
    }
    else if ((typeof value !== "string") && hasProperties) {
      removeNullProperties(value);
    }
  });
  return obj;
}

/**
 * object is valid
 * @param obj
 */
export const validObj = (obj: object | undefined) => !!(obj && Object.keys(obj).length);


export const deleteCookie = async() => {
  const cookie1 = 'cdp-cookie';
  document.cookie = cookie1 + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path='/';"
};

export const getCookie = (cname: any) => {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

export const setCookie = (cname: string,cvalue: string,exdays: number) => {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}


